import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider, useApp } from "./AppContext";
import { PrefetchProvider } from "./hooks/usePrefetch";
import ErrorBoundary from "./components/ErrorBoundary";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import AppLayout from "./pages/AppLayout";
import Dashboard from "./pages/Dashboard";
import Analytics from "./pages/Analytics";
import InvoicesList from "./pages/InvoicesList";
import InvoiceDetail from "./pages/InvoiceDetail";
import Reports from "./pages/Reports";
import Integrations from "./pages/Integrations";
import QuotesList from "./pages/QuotesList";
import QuoteBuilder from "./pages/QuoteBuilder";
import QuoteDetail from "./pages/QuoteDetail";
import Clients from "./pages/Clients";
import Projects from "./pages/Projects";
import Templates from "./pages/Templates";
import Assistant from "./pages/Assistant";
import SettingsPage from "./pages/SettingsPage";
import ErpDemo from "./pages/ErpDemo";
import ErpLeads from "./pages/ErpLeads";
import Billing from "./pages/Billing";
import { BillingSuccess, BillingCancel } from "./pages/BillingResult";
import { ForgotPassword, ResetPassword } from "./pages/PasswordPages";
import PublicQuoteView from "./pages/PublicQuoteView";
import ClientPortal from "./pages/ClientPortal";
import AcceptInvite from "./pages/AcceptInvite";
import Team from "./pages/Team";
import { TermsPage, PrivacyPage } from "./pages/LegalPages";
import { CookiesPage, AccessibilityPage, LegalNoticePage, SecurityPage, PrivacyRequestPage } from "./pages/LegalExtraPages";
import ReleasesPage from "./pages/ReleasesPage";
import AdminReleases from "./pages/AdminReleases";
import AppSecurityPage from "./pages/AppSecurityPage";
import VisionQuoteWizard from "./pages/VisionQuoteWizard";
import VisionHistory from "./pages/VisionHistory";
import ProgereConsentManager from "./components/ProgereConsentManager";
import ProgereReleasePopup from "./components/ProgereReleasePopup";

const Protected = ({ children }) => {
  const { token } = useApp();
  if (!token) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <ErrorBoundary>
      <AppProvider>
        <PrefetchProvider>
          <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/register" element={<Auth mode="register" />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/quote/share/:token" element={<PublicQuoteView />} />
          <Route path="/client-portal" element={<ClientPortal />} />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route path="/conditions" element={<TermsPage />} />
          <Route path="/confidentialite" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/temoins" element={<CookiesPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/accessibilite" element={<AccessibilityPage />} />
          <Route path="/accessibility" element={<AccessibilityPage />} />
          <Route path="/mentions-legales" element={<LegalNoticePage />} />
          <Route path="/legal-notice" element={<LegalNoticePage />} />
          <Route path="/securite" element={<SecurityPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/demande-confidentialite" element={<PrivacyRequestPage />} />
          <Route path="/privacy-request" element={<PrivacyRequestPage />} />
          <Route path="/nouveautes" element={<ReleasesPage />} />
          <Route path="/updates" element={<ReleasesPage />} />
          <Route path="/erp-demo" element={<ErpDemo />} />
          <Route path="/billing/success" element={<BillingSuccess />} />
          <Route path="/billing/cancel" element={<BillingCancel />} />
          <Route path="/app" element={<Protected><AppLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="invoices" element={<InvoicesList />} />
            <Route path="invoices/:id" element={<InvoiceDetail />} />
            <Route path="reports" element={<Reports />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="quotes" element={<QuotesList />} />
            <Route path="quotes/new" element={<QuoteBuilder />} />
            <Route path="quotes/:id" element={<QuoteDetail />} />
            <Route path="clients" element={<Clients />} />
            <Route path="projects" element={<Projects />} />
            <Route path="templates" element={<Templates />} />
            <Route path="assistant" element={<Assistant />} />
            <Route path="team" element={<Team />} />
            <Route path="erp-leads" element={<ErpLeads />} />
            <Route path="billing" element={<Billing />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="security" element={<AppSecurityPage />} />
            <Route path="quotes/new/vision" element={<VisionQuoteWizard />} />
            <Route path="vision/history" element={<VisionHistory />} />
            <Route path="admin/releases" element={<AdminReleases />} />
          </Route>
        </Routes>
        <ProgereConsentManager />
        <ProgereReleasePopup />
      </BrowserRouter>
      </PrefetchProvider>
    </AppProvider>
    </ErrorBoundary>
  );
}

export default App;
